export default __webpack_public_path__ + "static/logo-187e36eed442aa04414920b4021feddb.svg";